export default "__VITE_ASSET__CmPQUSp6__"